<div *ngIf="isLoading || saveInProgress" style="text-align: center;">
  <p-progressSpinner></p-progressSpinner>
</div>

<div *ngIf="!isLoading && !saveInProgress " class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Site Form Entry: {{ siteForm?.name }}</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <div class="skylark-form-entry" *ngIf="modalActive">
      <div class="background-inner">
        <ng-container *ngFor="let field of formData; let i = index;">

          <!-- inputs -->
          <!-- text field -->
          <ng-container *ngIf="field.type === 'textField'">
            <label>{{ field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">response required</span></label>
            <input type="text" [(ngModel)]="answers[i]"/>
          </ng-container>

          <!-- text area -->
          <ng-container *ngIf="field.type === 'textArea'">
            <label>{{ field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">response required</span></label>
            <textarea [(ngModel)]="answers[i]"></textarea>
          </ng-container>

          <!-- date field -->
          <ng-container *ngIf="field.type === 'dateField'">
            <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">date required</span></label>
            <input type="date" [(ngModel)]="answers[i]"/>
          </ng-container>

          <!-- time field -->
          <ng-container *ngIf="field.type === 'timeField'">
            <label>{{field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">time required</span></label>
            <input type="time" [(ngModel)]="answers[i]"/>
          </ng-container>

          <!-- radio button list -->
          <ng-container *ngIf="field.type === 'radioButton'">
            <div class="list-group">
              <span class="list-group-header">{{ field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">select one</span> </span>

              <ng-container *ngFor="let option of field.options; let ro = index">
                <div class="radio-button-line">
                  <label class="radio-label">
                    <input type="radio" [name]="'radio_' + i" [value]="option" [(ngModel)]="answers[i]">
                    {{option}}
                  </label>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- checkbox list -->
          <ng-container *ngIf="field.type === 'checkboxList'">
            <div class="list-group">
              <span class="list-group-header">{{ field.label }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">select at least one</span></span>
                <ng-container *ngFor="let option of field.options; let co = index" [ngValue]="option">
                <div class="checkbox-button-line">
                  <label class="radio-label">
                    <input type="checkbox" [name]="'checkbox_' + i" [value]="option" (change)="setCheckboxValue(i, option, $event)">
                    {{option}}
                  </label>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- image upload -->
          <ng-container *ngIf="field.type === 'imageUpload'">
            <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">attachment required</span></label>
            <div><button class="preview-button-primary" (click)="fileInput.click()">Attach photos</button></div>
            <input
                #fileInput
                type="file"
                class="form-control"
                accept={{globals.PHOTO_ACCEPTED_FILE_TYPES}}
                (change)="onFileChange($event, i)"
                multiple
                style="display: none;"
            />
            <ng-container *ngIf="selectedDocumentsArray[i]">
              <p>Selected Photos:</p>
              <ul>
                <li *ngFor="let file of selectedDocumentsArray[i]">{{ file.name }}</li>
              </ul>
            </ng-container>
          </ng-container>

          <!-- document upload -->
          <ng-container *ngIf="field.type === 'documentUpload'">
            <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span>&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">attachment required</span></label>
            <div><button class="preview-button-primary" (click)="fileInput.click()">Attach documents</button></div>
            <input
                #fileInput
                type="file"
                class="form-control"
                accept={{globals.ALL_ACCEPTED_FILE_TYPES}}
                (change)="onFileChange($event, i)"
                multiple
                style="display: none;"
            />
            <ng-container *ngIf="selectedDocumentsArray[i]">
              <p>Selected Documents:</p>
              <ul>
                <li *ngFor="let file of selectedDocumentsArray[i]">{{ file.name }}</li>
              </ul>
            </ng-container>
          </ng-container>

          <!-- table -->
          <ng-container *ngIf="field.type === 'table'">
            <label>{{ field.label }} <span *ngIf="field.required" class="required-star">*&nbsp;<span *ngIf="getErrorByKey(i)" class="required-star">Enter one row</span></span></label>
            <div class="table-wrapper">
            <table [id]="'my-table-' + i">
              <thead>
                <tr>
                  <th [attr.colspan]="field.fields.length + 1">{{field.label}}</th>
                </tr>
                <tr>
                  <th *ngFor="let fieldInner of field.fields">{{fieldInner.label}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of answers[i]; let r = index" (click)="onEditTableRow(i, r)">
                  <td *ngFor="let fieldInner of field.fields; let j = index">{{row[j]}}</td>
                  <td>
                    <a role="button" class="link-button"><button type="button" class="btn btn-primary btn-link">edit</button></a>
                  </td>
                </tr>
                <tr (click)="onEditTableRow(i, answers[i] ? answers[i].length : 0)">
                  <td *ngFor="let innerField of field.fields; let c = index"></td>
                  <td>
                    <a role="button" class="link-button"><button type="button" class="btn btn-primary btn-link">edit</button></a>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </ng-container>

          <!-- structure -->
          <ng-container *ngIf="field.type === 'headerLarge'">
            <h2>{{field.text ? field.text : 'Header' }}</h2>
          </ng-container>
          <ng-container *ngIf="field.type === 'headerSmall'">
            <h4>{{field.text ? field.text : 'Header' }}</h4>
          </ng-container>

          <ng-container *ngIf="field.type === 'paragraphOfText'">
            <p class="textarea">{{ field.textarea }}</p>
          </ng-container>

        </ng-container>
    </div>
  </div>

  <div *ngIf="validationErrors.length" class="validation-alert">
    <br/>
    <div *ngFor="let error of validationErrors" >
      <span class="required-star" *ngIf="!error.field">
      - {{error.message}}
      </span>
    </div>
    <span class="required-star">- Please fix all errors before proceeding</span>
  </div>
  <button class="btn btn-success btn-sm float-right"  (click)="submitForm()">Submit</button>
  <button class="btn btn-secondary btn-sm float-right" (click)="closeModal()">Cancel</button>
</div>

